import React from 'react';
import { MessageTimestamp, MessageTimestampProps } from 'stream-chat-react';

const CustomMessageTime = (
  props: React.PropsWithChildren<MessageTimestampProps>,
) => <MessageTimestamp {...props} format={'h:mma'} calendar={false} />;

export default CustomMessageTime;
